import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { Row, Col } from 'reactstrap';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import AttachCardV2 from '../../../components/cards/attachCardV2';

//Funciones
// import { handleFilesAdd, deleteFile } from '../../../utils/azureStorage/upload';
import { deleteFile, singleFileUploader } from '../../../utils/FirebaseStorage/FirebaseStorage';
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');

// Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalAdjutno = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [updFile, setUpdFile] = useState([]);
    const [fileAlreadyExist, setFileAlreadyExist] = useState(false);
    const [newState, setNewState] = useState();
    const [observacion, setObservacion] = useState();
    const [pos, setPos] = useState(-1);


    useEffect(() => {
        setNewState(props.newState ?? undefined)
    }, [])


    useEffect(() => {
        setNewState(props.newState)
    }, [props.newState])

    const handleUpload = async () => {
        try {
            props.setLoading(true)
            
            let tempFilesList = props.fileList
            if (updFile.length > 0) {
                for (const file of updFile) {
                    let newFile = await singleFileUploader(file, `APEFiles/${props.id}`, `${newState}${file.name.substring(file.name.lastIndexOf('.'))}`)
                    tempFilesList.push({ fileName: newFile[0].name })
                }
            }
            props.setFileList(tempFilesList)
            props.setLoading(false)
            props.toastSuccess('Archivo Cargado!')
        }
        catch (error) {
            console.log(error)
            props.toastError('Error al cargar archivo')
        }
    }

    const fileExist = (filename) => {
        const newArr = props.fileList.filter(file => file.fileName.split('.')[0] == filename)
        return { exists: newArr.length > 0, file: newArr.length > 0 ? newArr[0] : undefined }
    }

    const fileReadyToUpload = (filename) => {
        const newArr = updFile.filter(file => file.key === filename)
        return newArr.length > 0
    }

    const updateFile = (e) => {
        const tempArr = []
        tempArr.push(e)
        setUpdFile([...tempArr])
    }

    const updateAPE = async () => {
        let body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                cmp_stat: newState === 'REMISION' ? 'PRUEBAS' : 'ESTUDIO_SEGURIDAD'
            },

        }
        try {
            const req = await actualizarAPE(body)
            toastSuccess('APE actualizada!')
        }
        catch (error) {
            console.log(error)
            toastSuccess('Hubo un error!')
        }
    }

    const handleUpdate = async () => {
        if (!fileAlreadyExist || updFile !== undefined) await handleUpload();
        await updateAPE({ observacion });
        props.updateAPE({ estadoAPE: newState === 'REMISION' ? 'PRUEBAS' : 'ESTUDIO_SEGURIDAD' })
        props.toastSuccess('Estado Actualizado!');
        props.toggle();
    }

    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Actualizar'}
                onClick={() => handleUpdate()}
                buttonLoading={!(updFile.length > 0 || fileExist(`${newState}`))}
                title={`Actualizar estado a ${newState}`}
            >
                <Row>
                    <Col lg='3' md='3' xs='12'>
                        <AttachCardV2
                            id={`${newState}`}
                            subText={`${newState}`}
                            attached={fileReadyToUpload(`${newState}`) || fileExist(`${newState}`).exists}
                            file={fileExist(`${newState}`).file}
                            apeId={props.id}
                            fileList={props.fileList}
                            setLoading={(e) => props.setLoading(e)}
                            setFileList={(e) => { props.setFileList(e) }}
                        /></Col>
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalAdjutno);